import { Grid, Paper, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import React, { useState } from "react";
import { ReactComponent as Info } from "icons/Info.svg";
import { impactAssessmentStyles } from "./ImpactAssessmentStyles";
import clsx from "clsx";
import TemperatureCard from "components/TemperatureCard/TemperatureCard";
import { ImpactAssessmentProps } from "./ImpactAssessmentProps";

export default observer(function ImpactAssessment({ highBandSummary, lowBandSummary, batchId }: ImpactAssessmentProps) {
    const classes = impactAssessmentStyles();

    const [tooltipOpen, setTooltipOpen] = useState(false);

    const handleClose = () => {
        setTooltipOpen(false);
    };

    const handleOpen = () => {
        setTooltipOpen(true);
    };
    return (
        <div className={classes.main}>
            <div style={{ position: "absolute" }}>
                <Typography variant="h4" className={classes.title}>
                    Impact Assessment
                    <Info className={classes.icon} onMouseEnter={handleOpen} onMouseLeave={handleClose} />
                </Typography>
                <Paper
                    elevation={0}
                    className={clsx(classes.tooltip, {
                        [classes.hide]: !tooltipOpen,
                    })}
                    onMouseEnter={handleOpen}
                    onMouseLeave={handleClose}
                >
                    <Typography className={classes.tooltipTitle}>How we calculate remaining hours</Typography>
                    <br />
                    <Typography className={classes.tooltipText}>
                        The displayed value of remaining stability time always represents the worst case scenario for
                        the specific temperature band (high or low). The temperature range represents the worst case
                        temperature range to date that the batch experienced for the temperature band. To review details
                        of the calculations expand “Show ranges and historical events„
                    </Typography>
                </Paper>
            </div>
            <Grid container>
                <Grid item xs={6}>
                    <TemperatureCard
                        excursionType={"Low"}
                        rsb={lowBandSummary.rsb}
                        lowerLimit={lowBandSummary.lowerLimit}
                        upperLimit={lowBandSummary.upperLimit}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TemperatureCard
                        excursionType={"High"}
                        rsb={highBandSummary.rsb}
                        lowerLimit={highBandSummary.lowerLimit}
                        upperLimit={highBandSummary.upperLimit}
                    />
                </Grid>
            </Grid>
        </div>
    );
});
